<template>
  <div class="form__field" style="width: 30em">
    <div class="form__title">Sicherheitscode</div>
    <div class="form__spacer"></div>
    <div>
      <img :src="captchaUrlBase + 'captcha'" alt="captcha"/>
    </div>
    <div class="form__control" style="width: 100px">
      <input
        autocomplete="off"
        class="form__input"
        type="text"
        maxlength="6"
        v-model="value"
        id="_captcha"
        name="_captcha"
        @blur="validate"
        @input="inputHandler"
      />
    </div>
    <div class="form__description mod mod--style--normal mod--theme--primary mod--size--14 mod--weight--400">
      Geben Sie bitte den Sicherheitscode ein.
    </div>
    <div
      class="form__message form__message--error"
      v-show="error"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import Api from "../api/api";

export default {
  props: {
    state: Object
  },
  data() {
    return {
      value: "",
      error: null,
      captchaFieldDisplay: null,
    };
  },
  methods: {
    validate() {
      if (/^[A-z0-9]{6}$/.test(this.value)) {
        this.error = null;
      }
      else {
        this.error = "Ungültiger Sicherheitscode";
      }
    },
    inputHandler() {
      Api.CAPTCHA = this.value;
      const captchaInput = document.getElementById('_recaptcha');
      captchaInput && (captchaInput.value = this.value);
      this.$emit("update", "captcha", this.value);
    }
  },
  computed: {
    captchaUrlBase() {
      return process.env.NODE_ENV === "development"
        ? "http://shopulm.netz.indianer/"
        : "/";
    }
  },
  mounted() {
    const captchaField = document.getElementById("_captchaField");
    this.captchaFieldDisplay = captchaField && captchaField.style.display;
    captchaField && (captchaField.style.display = "none");
  },
  beforeDestroy() {
    const captchaField = document.getElementById("_captchaField");
    captchaField && (captchaField.style.display = this.captchaFieldDisplay);
  }
};
</script>
